import { useState, useEffect } from "react";

export function useGetByBreakpoint(query, start, end) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    let mediaQuery;

    // Helper: convert numbers to px strings
    const px = (val) => (typeof val === "number" ? `${val}px` : val);

    // Build query string based on type
    if (query === "up") {
      mediaQuery = window.matchMedia(`(min-width: ${px(start)})`);
    } else if (query === "down") {
      mediaQuery = window.matchMedia(`(max-width: ${px(start)})`);
    } else if (query === "between" && end) {
      mediaQuery = window.matchMedia(
        `(min-width: ${px(start)}) and (max-width: ${px(end)})`
      );
    } else if (query === "only") {
      // For 'only', treat it as exact range ±100px window
      const min = typeof start === "number" ? start - 100 : 0;
      const max = typeof start === "number" ? start + 100 : 9999;
      mediaQuery = window.matchMedia(
        `(min-width: ${px(min)}) and (max-width: ${px(max)})`
      );
    }

    const handleChange = () => setMatches(mediaQuery.matches);

    if (mediaQuery) {
      handleChange(); // initialize
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    }
  }, [query, start, end]);

  return matches;
}

export function useGetByDevice() {
  const isDesktop = useGetByBreakpoint("up", 1200);
  const isTablet = useGetByBreakpoint("between", 768, 1200);
  const isMobile = useGetByBreakpoint("down", 768);
  const isXsMobile = useGetByBreakpoint("down", 376);
  const isXsDesktop = useGetByBreakpoint("between", 1024, 1400);

  const [isLandscape, setLandscape] = useState(false);
  const [isPortrait, setPortrait] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      setLandscape(window.matchMedia("(orientation: landscape)").matches);
      setPortrait(window.matchMedia("(orientation: portrait)").matches);
    };

    checkOrientation();
    window.addEventListener("resize", checkOrientation);
    return () => window.removeEventListener("resize", checkOrientation);
  }, []);

  const isPortable = isMobile || isTablet;

  return {
    isDesktop,
    isTablet,
    isMobile,
    isXsMobile,
    isXsDesktop,
    isPortable,
    isLandscape,
    isPortrait,
  };
}
